import React from 'react';
import './_checkbox.scss';

export default function Checkbox({ checked, onChange, children, className = '' }) {
  return (
    <label className={`Checkbox ${className}`}>
      <input type="checkbox" className="Checkbox__input" checked={checked} onChange={onChange} />
      <span className="Checkbox__box">
        <svg
          className="Checkbox__icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </span>
      {children && <span className="Checkbox__label">{children}</span>}
    </label>
  );
}
